import { Button, ButtonProps } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { PropsWithChildren } from 'react';

type PaginationButtonProps = {
    page?: number | null;
    disabled?: boolean;
    onClick?: (page: number | null) => void;
    styleProps?: ButtonProps;
};

export const PaginationButton = (props: PropsWithChildren<PaginationButtonProps>) => {
    const { children, page = 1, disabled, styleProps } = props;

    const router = useRouter();

    return (
        <Button
            key={router.asPath}
            disabled={disabled}
            colorScheme="blue"
            borderRadius="21px"
            p={2}
            onClick={() => props?.onClick?.(page)}
            {...styleProps}
        >
            {children}
        </Button>
    );
};
